<footer class="dish-footer-container">
  <div class="footer-links-container">
    <a href="https://www.dish.co/DE/en/terms-of-use">{{ 'csa.footer.terms' | translate }}</a>
    <a href="https://www.dish.co/DE/en/data-privacy">{{ 'csa.footer.privacy' | translate }}</a>
    <a href="https://www.dish.co/DE/en/imprint">{{ 'csa.footer.imprint' | translate }}</a>
    <a href="https://www.dish.co/DE/en/cookies">{{ 'csa.footer.cookies' | translate }}</a>
  </div>
  <hr />
  <div class="dish-link-container">
    <p>&#64;DISH 2019</p>
  </div>
</footer>
